import { useEffect } from "react";
import { ActionConfirmation, useHasActionOutcomeHost, usePublishActionOutcome } from "../ui/ActionConfirmation.js";
/**
 * Locked view for a registration the server has already accepted. It offers no
 * editable fields: retry replays the captured payload and key, never a new sale.
 */
export function AcceptedRegistrationRecovery({
  title,
  message,
  problem,
  busy,
  onRetry,
  onClose,
}: {
  title: string;
  message: string;
  problem: string | null;
  busy: boolean;
  onRetry: () => void;
  onClose: () => void;
}) {
  const hasHost = useHasActionOutcomeHost();
  const publish = usePublishActionOutcome();
  useEffect(() => {
    publish({ variant: "attention", title: "Lesson block needs attention", description: title, details: [{ value: message }] });
  }, [publish, title, message]);
  const controls = <>
      {problem && <div className="error small">{problem}</div>}
      <div className="row" style={{ marginTop: 12 }}>
        <button type="button" onClick={onRetry} disabled={busy}>
          {busy ? "Updating…" : "Retry existing block settlement"}
        </button>
        <button type="button" className="quiet" onClick={onClose} disabled={busy}>
          Close
        </button>
      </div>
    </>;
  return hasHost ? <div>{controls}</div> : <ActionConfirmation variant="attention" title="Lesson block needs attention" description={title} details={[{ value: message }]} action={controls} />;
}
